import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { get } from 'lodash'
import { COLORS } from 'src/utils/Themes/colors'
import CloseButton from 'src/components/common/CloseButton'
import RiskCategoryContentItem from 'src/components/RiskCategories/RiskCategoryContentItem'
import NavigateBackButton from 'src/components/common/NavigateBackButton'
import {
  EMPTY_MSG_WORKING_ON_OTHER_PRODUCTS,
  EMPTY_MSG_WORKING_ON_RECOMMENDED_POLICIES,
} from 'src/utils/constants/RiskCategory'

const RiskCategorieContent = ({ data, handleClose, handleClickEvent }) => {
  const classes = useStyles()
  const [availableList, setAvailableList] = useState([])
  const [recommendedList, setRecommendedList] = useState([])
  const [othersList, setOthersList] = useState([])
  const [subInsuranceList, setSubInsuranceList] = useState([])
  const [subInsuranceMainType, setSubInsuranceMainType] = useState()
  const [isSubInsuranceView, setIsSubInsuranceView] = useState(false)
  const [title, setTitle] = useState()

  useEffect(() => {
    if (data) {
      const available = get(data, 'riskData.available', [])
      const recommended = get(data, 'riskData.recommended', [])
      const others = get(data, 'riskData.others', [])
      if (available) setAvailableList(available)
      if (recommended) setRecommendedList(recommended)
      if (others) setOthersList(others)
    }
  }, [data])

  const handleSubInsuranceClick = (insuranceData) => {
    if (
      insuranceData?.subInsuranceData &&
      insuranceData?.subInsuranceData?.length > 0
    ) {
      setSubInsuranceMainType(insuranceData?.insuranceName)
      setSubInsuranceList(insuranceData?.subInsuranceData)
      setIsSubInsuranceView(true)
      setTitle(insuranceData?.insuranceName)
    } else {
      handleClickEvent(insuranceData)
    }
  }

  const handleSubTypeClick = (insuranceData) => {
    let insuranceDataSubType = {
      image: insuranceData?.image,
      productSubType: insuranceData?.productSubType,
      insuranceName: subInsuranceMainType,
    }

    handleClickEvent(insuranceDataSubType)
  }

  const handleSubTypeBackButton = () => {
    setSubInsuranceList([])
    setTitle(null)
    setIsSubInsuranceView(false)
  }

  return (
    <>
      <div
        className={`${classes.modalRiskInsurencesContent} ${
          data?.className ?? ''
        }`}
      >
        {subInsuranceList?.length > 0 && (
          <div className={classes.backBtn}>
            <NavigateBackButton
              tooltipTitle='Back'
              handleClick={handleSubTypeBackButton}
            />
          </div>
        )}
        <CloseButton
          classname={classes.closeBtn}
          title='Close'
          handleClose={handleClose}
          id='closeButton'
        />

        <h2>{title ?? data?.title}</h2>
        {isSubInsuranceView ? (
          <>
            {subInsuranceList?.length > 0 && (
              <div className={classes.commonMargin}>
                <RiskCategoryContentItem
                  id='subInsuranceItem'
                  keyLabel='subInsuranceItem'
                  heading='Presently Available Subtypes'
                  dataArray={subInsuranceList}
                  hasClickEvent={true}
                  handleClick={(d) => handleSubTypeClick(d)}
                />
              </div>
            )}
          </>
        ) : (
          <>
            <div>
              <RiskCategoryContentItem
                id='availableItem'
                keyLabel='available-item'
                heading='Presently Available'
                dataArray={availableList}
                custClass=''
                hasClickEvent={true}
                handleClick={(d) => {
                  handleSubInsuranceClick(d)
                }}
              />
            </div>

            <div className={classes.commonMargin}>
              <RiskCategoryContentItem
                id='recommendedItem'
                keyLabel='recommended-item'
                heading='Recommended to buy'
                dataArray={recommendedList}
                custClass={classes.recommendedTile}
                hasClickEvent={true}
                handleClick={(d) => handleClickEvent(d)}
                emptyDataMessage={EMPTY_MSG_WORKING_ON_RECOMMENDED_POLICIES}
              />
            </div>

            <div className={classes.commonMargin}>
              <RiskCategoryContentItem
                id='otherItem'
                keyLabel='other-item'
                heading='Other Available Products'
                dataArray={othersList}
                emptyDataMessage={EMPTY_MSG_WORKING_ON_OTHER_PRODUCTS}
              />
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default RiskCategorieContent

const useStyles = makeStyles({
  modalRiskInsurencesContent: {
    padding: '0% 8%',
    position: 'relative',
    '& h2': {
      fontSize: '22px',
      fontWeight: 600,
      marginTop: 5,
    },
    '& h3': {
      fontSize: '16px',
      fontWeight: 500,
      marginTop: 25,
      marginBottom: 15,
    },
  },
  commonMargin: {
    marginTop: '-15px',
  },
  tilesWrapper: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: '14px',
    alignItems: 'center',
    justifyContent: 'center',
    color: COLORS.GREY,
    padding: '8px 8px',
    background: COLORS.WHITE,
  },
  tileCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 24px',
    borderRadius: '10px',
    margin: '0px 10px 22px',
    cursor: 'pointer',
    minHeight: '48px',
    maxWidth: '230px',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: COLORS.WHITE,
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
    '&:hover': {
      border: `1px solid ${COLORS.DARK_PINK}`,
      color: COLORS.DARK_PINK,
    },
    border: `1px solid ${COLORS.WHITE}`,
  },
  recommendedTile: {
    border: `1px solid ${COLORS.DARK_PINK}`,
    // borderColor: COLORS.DARK_PINK,
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
    '&:hover': {
      color: COLORS.DARK_PINK,
      fontWeight: '600',
    },
  },
  icon: {
    width: '26px',
    margin: '0 8px 0 0',
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    '& img': {
      maxWidth: '100%',
    },
  },
  title: {
    fontSize: '14px',
    lineHeight: '16px',
    color: 'inherit',
    boxSizing: 'border-box',
    fontWeight: 500,
  },
  closeBtn: {
    position: 'absolute',
    right: 0,
  },
  emptyData: {
    fontSize: '12px',
    color: '#ababab',
    marginTop: '20px',
    display: 'inline-block',
  },
  backBtn: {
    position: 'absolute',
    left: '0px',
    top: '-3px',
  },
})
